module.exports = __webpack_public_path__ + "img/processing.bbc37c99.svg";